import { getTeams } from "core-integration/src/store/teams/reducers";
import { RadioButton } from "plos/src/components/forms/RadioButton";
import { RadioButtonGroup } from "plos/src/components/forms/ReactHookFormControlled/RadioButtonGroup";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { TeamBuilderPreferencesFormData } from "../../../types";
import {
  getFavouriteTeamSubtitle,
  getPreferFavouriteTeamChoices,
} from "../../../utils";

interface FavouriteTeamFormProps {
  favouriteTeam: number | null;
}

const FavouriteTeamForm = ({ favouriteTeam }: FavouriteTeamFormProps) => {
  const { control } = useFormContext<TeamBuilderPreferencesFormData>();
  const { t } = useTranslation("onboarding");
  const preferFavouriteTeamChoices = getPreferFavouriteTeamChoices(t);

  const teams = useSelector(getTeams);

  const selectedValidTeam = teams.find(
    (team) => team.id === Number(favouriteTeam),
  )?.name;

  const selectedTeamLabel = getFavouriteTeamSubtitle(t, selectedValidTeam);

  return (
    <RadioButtonGroup
      control={control}
      name="preferFavouriteTeam"
      rules={{ required: selectedValidTeam ? true : false }}
      id="preferFavouriteTeam"
      label={selectedTeamLabel}
      hideLabel
    >
      {selectedValidTeam &&
        preferFavouriteTeamChoices.map(({ value, label, extendedLabel }) => (
          <RadioButton
            key={value}
            value={value}
            autoFocus={value === "yes"}
            fontWeight="regular"
            description={extendedLabel}
          >
            {label}
          </RadioButton>
        ))}
    </RadioButtonGroup>
  );
};

export default FavouriteTeamForm;
